/**
 * Where releases live in the URL (2026-09-13).
 *
 * A release is a PLACE now — `/crm/releases/10.2` — not a `?release=` param on
 * a shared page, so a link pasted to a colleague names the release in its
 * path and the browser's back button leaves the release for the folders.
 * Which version inside it is open rides as `?version=10.2.0.27`, the same
 * way a detail page's tab does, because it is a view choice within the place
 * rather than a different place.
 *
 * Pure, so the redirect from the old address can be pinned without a router.
 */

export const RELEASES_PATH = "/crm/releases";

/** `?version=` — which version inside the release is selected. */
export const VERSION_PARAM = "version";

/** The page for one release, by the number printed on it. */
export function releasePath(releaseVersion: string): string {
  return `${RELEASES_PATH}/${encodeURIComponent(releaseVersion)}`;
}

/** The page for one release with one of its versions selected. */
export function versionPath(releaseVersion: string, version: string): string {
  return `${releasePath(releaseVersion)}?${VERSION_PARAM}=${encodeURIComponent(version)}`;
}

/**
 * Where an address from before the split lands.
 *
 * `/crm/licences/releases` was the Releases tab of the joint section, and
 * `?release=10.2` the folder open on it. A pasted link from last week still
 * has to open the same release, so the param becomes the path.
 */
export function legacyReleasesTarget(search: string): string {
  const release = new URLSearchParams(search).get("release");
  return release ? releasePath(release) : RELEASES_PATH;
}
